import { gql } from '@apollo/client'

export const CREATE_TEMPLATE = gql`
  mutation CreateTemplate($input: CreateContentTemplateInput!) {
    createContentTemplate(input: $input) {
      template {
        id
        channel
        name
        description
        subjectTemplate
        bodyTemplate
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_TEMPLATE = gql`
  mutation UpdateTemplate($input: UpdateContentTemplateInput!) {
    updateContentTemplate(input: $input) {
      template {
        id
        channel
        name
        description
        subjectTemplate
        bodyTemplate
        createdAt
        updatedAt
      }
    }
  }
`

export const DELETE_TEMPLATE = gql`
  mutation DeleteTemplate($input: DeleteContentTemplateInput!) {
    deleteContentTemplate(input: $input) {
      template {
        id
        name
        channel
        description
      }
    }
  }
`
